exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-62da16d5]{display:flex;flex-direction:column;align-items:center;grid-area:SL;background:var(--tertiary);padding:11px 0;max-height:100vh;overflow-y:scroll}.container[data-v-62da16d5]::-webkit-scrollbar{display:none}.separetion[data-v-62da16d5]{width:32px;margin-bottom:8px;border-bottom:2px solid var(--quaternary)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62da16d5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Server-List/index.vue
// module id = 39
// module chunks = 0